import { useRef } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { GripVertical, ChevronUp, ChevronDown } from "lucide-react";

// Orden manual compartido (orden_pos.<area>); los pedidos sin posición quedan al final en su orden original.
export const sortManual = (list, area) => {
  const k = (o) => (typeof o.orden_pos?.[area] === "number" ? o.orden_pos[area] : Infinity);
  return list
    .map((o, i) => [o, i])
    .sort((a, b) => (k(a[0]) - k(b[0])) || (a[1] - b[1]))
    .map((x) => x[0]);
};

export const PRIO_ROW = "bg-red-100 hover:bg-red-200";

export function useManualOrder(area, list, setOrders, base = 0) {
  const dragIdx = useRef(null);
  const commit = (arr) => {
    const pos = Object.fromEntries(arr.map((o, i) => [o.id, base + i]));
    setOrders((prev) => prev.map((o) => (o.id in pos ? { ...o, orden_pos: { ...(o.orden_pos || {}), [area]: pos[o.id] } } : o)));
    api.put("/orders/orden-manual", { area, ids: arr.map((o) => o.id), base }).catch((e) => toast.error(formatApiError(e)));
  };
  const move = (from, to) => {
    if (to < 0 || to >= list.length || from === to) return;
    const arr = [...list];
    const [it] = arr.splice(from, 1);
    arr.splice(to, 0, it);
    commit(arr);
  };
  const handleProps = (i) => ({
    draggable: true,
    onDragStart: (e) => {
      dragIdx.current = i;
      e.dataTransfer.effectAllowed = "move";
      const row = e.currentTarget.closest("[data-drag-row]");
      if (row) e.dataTransfer.setDragImage(row, 20, 20);
    },
  });
  const rowProps = (i) => ({
    "data-drag-row": true,
    onDragOver: (e) => { if (dragIdx.current !== null) e.preventDefault(); },
    onDrop: (e) => {
      if (dragIdx.current === null) return;
      e.preventDefault();
      move(dragIdx.current, i);
      dragIdx.current = null;
    },
  });
  return { move, handleProps, rowProps };
}

export const MoveHandle = ({ i, n, move, handleProps, testid }) => (
  <div className="inline-flex flex-col items-center shrink-0" data-testid={testid}>
    <button type="button" onClick={() => move(i, i - 1)} disabled={i === 0} className="text-zinc-400 hover:text-[#002FA7] disabled:opacity-20" title="Subir" data-testid={`${testid}-up`}>
      <ChevronUp className="w-4 h-4" />
    </button>
    <span {...handleProps(i)} className="cursor-grab active:cursor-grabbing text-zinc-400 hover:text-zinc-800 rounded-full bg-zinc-100 px-0.5 py-1" title="Arrastrar para mover" data-testid={`${testid}-drag`}>
      <GripVertical className="w-3.5 h-3.5" />
    </span>
    <button type="button" onClick={() => move(i, i + 1)} disabled={i === n - 1} className="text-zinc-400 hover:text-[#002FA7] disabled:opacity-20" title="Bajar" data-testid={`${testid}-down`}>
      <ChevronDown className="w-4 h-4" />
    </button>
  </div>
);
